import { React, Button, useRef } from "../../services/common";
import Header from '../../components/Common/Header/Header';
import { Link } from "react-router-dom";
import { Card } from 'react-bootstrap';
import data from "./assets/categories.json";
import students_data from "./assets/students.json";
import courses from "./assets/courses.json"
import landing from "../../assets/images/Img.png";
import landingmobile from "../../assets/images/Home-Mobile.png"
import tutorsList from "../../assets/images/tutorsList.png"
import topfeatures from "./assets/features.json";
import benefits from "../../assets/images/benefits.svg";
import musicseekho from "../../assets/images/footer/Music Seekho.svg";
import facebook from "../../assets/images/footer/Facebook.svg";
import instagram from "../../assets/images/footer/Instagram.svg";
import linkedin from "../../assets/images/footer/Linkedin.svg";
import twitter from "../../assets/images/footer/Twitter.svg";
import map from "../../assets/images/footer/Map Pin.svg";
import phone from "../../assets/images/footer/Phone.svg";
import emailicon from "../../assets/images/footer/Email.svg";
import arrowicon from "../../assets/images/arrow.svg";
import expert from "../../assets/images/trust-badges/Expert Instructor.svg";
import demo from "../../assets/images/trust-badges/Free Demo.svg";
import affordable from "../../assets/images/trust-badges/Affordable Pricing.svg";
import flexible from "../../assets/images/trust-badges/Flexible Scheduling.svg";

import "./Home.css";


const Home = () => {
    const contacts = data;
    const students = students_data;
    const features = topfeatures;
    const courseList = courses;
    const name = useRef();
    const message = useRef();
    const emailAddress = "meetings@musicseekho.com";
    const subject = "Query for Music Seekho";
    const benefitsArray = [
        "Music learning anytime, anywhere: convenience & flexibility",
        "Relax from daily stress with engaging musical activities",
        "Enhance focus, discipline with productive music immersion",
        "Gain Confidence through continuous improvement"];

    const sendEmail = () => {
        const body = encodeURIComponent(`Name: ${name.current.value}\n\n${message.current.value}`);
        window.location.href = `mailto:${emailAddress}?subject=${subject}&body=${body}`;
    };

    function FadeInSection(props) {
        const [isVisible, setVisible] = React.useState(false);
        const domRef = React.useRef();
        React.useEffect(() => {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => setVisible(entry.isIntersecting));
            });
            observer.observe(domRef.current);
        }, []);
        return (
            <div
                className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
                ref={domRef}>
                {props.children}
            </div>
        );
    }

    return (
        <>
            <Header home = {true}/>
            <div>
                <div>
                    <img className = "w-100 landing-image" src={landing} alt="Landing Page for Music Seekho">
                    </img>
                    <div className="main-heading">
                        <div className="headline">
                            <span>The Best experience
                                of <span className="main-keyword">Learning Music</span>
                            </span>
                        </div>
                        <div className="headline-detail">
                            Elevate Your Musical Skills: Embrace the Future of Learning with Our Dynamic and Interactive Platform!
                        </div>
                        <div className="headline-buttons">
                            <Link to="/tutors" className="get-started get-started-text">
                                Get Started
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_118_182)">
                                        <path d="M16.172 10.9999L10.808 5.63592L12.222 4.22192L20 11.9999L12.222 19.7779L10.808 18.3639L16.172 12.9999H4V10.9999H16.172Z" fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_118_182">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </Link>

                            <Link to="https://www.youtube.com/channel/UCWt0amvTA9yQYj4Mc4sBnkQ" target="_blank" className="get-started-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.00195 16.9993C5.00195 23.6266 10.3741 28.9987 17.0013 28.9987C23.6285 28.9987 29.0007 23.6266 29.0007 16.9993C29.0007 10.3721 23.6285 5 17.0013 5C10.3741 5 5.00195 10.3721 5.00195 16.9993ZM23.7892 23.7872C21.9889 25.5875 19.5472 26.5988 17.0013 26.5988C14.4554 26.5988 12.0137 25.5875 10.2134 23.7872C8.41319 21.987 7.40182 19.5453 7.40182 16.9993C7.40182 14.4534 8.41319 12.0117 10.2134 10.2115C12.0137 8.41124 14.4554 7.39987 17.0013 7.39987C19.5472 7.39987 21.9889 8.41124 23.7892 10.2115C25.5894 12.0117 26.6008 14.4534 26.6008 16.9993C26.6008 19.5453 25.5894 21.987 23.7892 23.7872ZM21.2023 16.5998L15.3478 12.6976C15.2756 12.6494 15.1916 12.6217 15.1049 12.6175C15.0182 12.6132 14.932 12.6325 14.8554 12.6734C14.7788 12.7143 14.7147 12.7752 14.67 12.8496C14.6253 12.924 14.6016 13.0091 14.6014 13.096V20.9027C14.6017 20.9894 14.6255 21.0743 14.6701 21.1485C14.7148 21.2227 14.7787 21.2835 14.8551 21.3243C14.9315 21.3652 15.0175 21.3846 15.1041 21.3805C15.1906 21.3764 15.2744 21.349 15.3466 21.3011L21.2023 17.3989C21.2681 17.3551 21.3221 17.2957 21.3594 17.226C21.3968 17.1563 21.4163 17.0784 21.4163 16.9993C21.4163 16.9203 21.3968 16.8424 21.3594 16.7727C21.3221 16.703 21.2681 16.6436 21.2023 16.5998Z" fill="white" />
                                </svg>
                                <span className="watch-video">
                                    Watch Video</span>
                            </Link>
                        </div>

                        <div className="trusted-by">
                            <div className = "badges">
                                <img src = {expert}></img>
                                <img src = {demo}></img>
                                <img src = {affordable}></img>
                                <img src = {flexible}></img>
                            </div>
                        </div>
                    </div>
                </div>
                <FadeInSection>
                    <div className="music-category">
                        <span className="explore">&nbsp; by Category</span>
                        <div className="items">
                            {contacts.map((contact) => (
                                <Card className={"categories " + contact.background} onMouseOver={(e) => e.currentTarget.querySelector('.category-image').src = contact.hoverIcon}
                                    onMouseOut={(e) => e.currentTarget.querySelector('.category-image').src = contact.icon}>
                                    <Card.Img className="category-image" variant="top" src={contact.icon} />
                                    <Card.Body className="category-card">
                                        <span className="category-type">{contact.type}</span>
                                        <div className="category-about">{contact.about}</div>
                                        <Link to="/courses" className="course-link"> <span className="learn-more">Learn More
                                            <img className="arrow-learn-more" src={arrowicon}></img>
                                        </span>
                                        </Link>
                                    </Card.Body>
                                </Card>

                            ))}
                        </div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="tutors">
                        <div className="row">
                            <div className="col-5 tutor-text">
                                <div className="our-tutors">Our Tutors</div>
                                <div className = "tutor-description">At our platform, our exceptional instructors, hailed as the best tutors, blend expertise, passion, and personalized guidance into every session. With interactive and fun teaching methods, whether beginner or advanced, unlock your full potential with tailored instruction. Join us for a transformative learning experience, empowering you to excel in your musical journey with confidence and creativity. Discover the magic of music today!</div>
                                <Link className="view-tutors" to="/tutors">
                                    View All Tutors
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g clip-path="url(#clip0_118_182)">
                                            <path d="M16.172 10.9999L10.808 5.63592L12.222 4.22192L20 11.9999L12.222 19.7779L10.808 18.3639L16.172 12.9999H4V10.9999H16.172Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_118_182">
                                                <rect width="24" height="24" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </Link>
                            </div>
                            <div className="col-7 tutor-images">
                                <img className = "w-100" src={tutorsList} alt="All Music Tutors List" >
                                </img>
                            </div>
                        </div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="top-features">
                        <div className="feature-body">
                            <div className="feature-heading">
                                Top Features you can get
                            </div>
                            <div className="feature-text">
                                Explore our features to enhance your music learning with Music Seekho. Elevate your skills effortlessly.
                            </div>
                            <Link to="/tutors" className="get-started-feature">
                                Get Started
                            </Link>
                        </div>
                        <div className="items">
                            {features.map((feature) => (
                                <Card className="features-container">
                                    <Card.Img className="feature-image" variant="top" src={feature.image} />
                                    <Card.Body className="category-card">
                                        <span className="feature-title">{feature.heading}</span>
                                        <div className="feature-about">{feature.about}</div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="top-courses">
                        <span className="course-headline">Our Most <span className="popular-courses">Popular Courses</span></span>
                        <div className="course-title">Join our top-rated classes led by our accomplished instructors.</div>
                        <div className="items">
                            {courseList.map((course) => (
                                <Link to="/courses" className="course-link">
                                    <Card className="courses" >
                                        <Card.Img className="course-image" variant="top" src={course.course_image} />
                                        <Card.Body>
                                            {/* <Card.Img src={course.rating}></Card.Img> */}
                                            <div className="course-about">{course.about}</div>
                                            <hr></hr>
                                            <div>
                                                <Card.Img className="course-tutor" src={course.tutor_image}></Card.Img>
                                                <span className="course-tutor-name">{course.tutor_name}</span>
                                                <div className="course-name">{course.name}</div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Link>
                            ))}
                        </div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="benefits row">
                        <div className="col-6 benefit-section">
                            <img className="benefit-image" src={benefits} alt="Benefits of using our music platform"></img>
                        </div>
                        <div className="col-6 benefit-section">
                            <div className="benefit-heading">What Benefit You Will Get</div>
                            {benefitsArray.map((benefit) => (
                                <div className="benefit-list">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM15.6318 19.8961L21.8379 13.4961L20.4021 12.1039L14.8858 17.7926L11.5695 14.6357L10.1905 16.0843L14.2245 19.9243L14.9421 20.6074L15.6318 19.8961Z" fill="#7F56D9" />
                                    </svg><span className="benefit-text">{benefit}</span></div>
                            ))}
                        </div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="testimonials">
                        <div className="testimonial-heading">
                            Testimonials
                        </div>
                        <span className="testimonial-title">What our student say about us</span>
                        <div className="testimonial-container">
                            {students.map((student) => (
                                <Card className="testimonial-card">
                                    <div className="testimonial-review">
                                        <Card.Img className="student-image" src={student.image} />
                                        <Card.Title className="student-name">{student.name}</Card.Title>
                                    </div>
                                    <div>
                                        <Card.Text className="student-review"><p>{student.review}</p></Card.Text>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </div>
                </FadeInSection>

                <FadeInSection>
                    <div className="footer-music">
                        <div className="row">
                            <div className="col-6 footer-container">
                                <img src={musicseekho} alt="Get in touch with Music Seekho, our music learning platform">
                                </img>
                                <div className="footer-company">
                                    © Music Seekho, 2023
                                </div>

                                <div className="social-icons">
                                    <Link to="https://www.facebook.com/people/Music-Seekho/100081724186098/?mibextid=LQQJ4d" target="_blank" >
                                        <img src={facebook} alt="Connect with Music Seekho on Facebook"></img>
                                    </Link>
                                    <Link to="https://twitter.com/musicseekho" target="_blank" >
                                        <img src={twitter} alt="Connect with Music Seekho on Twitter"></img>
                                    </Link>
                                    <Link to="https://in.linkedin.com/company/music-seekho" target="_blank" >
                                        <img src={linkedin} alt="Connect with Music Seekho on Linkedin"></img>
                                    </Link>
                                    <Link to="https://www.instagram.com/musicseekho" target="_blank" >
                                        <img src={instagram} alt="Connect with Music Seekho on Instagram"></img>
                                    </Link>
                                </div>
                                <div className="contact">
                                    <span className="contact-us">Contact Us</span>
                                    <p className="inquiry">
                                        Have an inquiry? We'll be happy to assist you.
                                    </p>
                                    <div className="contact-details">
                                        <span>
                                            <img className="contact-icons" src={phone} alt="Contact Details of Music Seekho, music teachinhg and learning platform"></img>
                                            +91 98 773 46698
                                        </span>
                                        <span>
                                            <img className="contact-icons" src={emailicon} alt="Email Address of Music Seekho"></img>
                                            meetings@musicseekho.com
                                        </span>
                                        <span>
                                            <img className="contact-icons" src={map} alt="Address of Music Seekho"></img>
                                            Chandigarh, India
                                        </span>
                                    </div>
                                </div>

                            </div>
                            <div className="col-6 flex">
                                <div className="fill-form">
                                    <div className="fill-details">
                                        <div className="form-details">
                                            <div className="footer-form">
                                                Fill in your details
                                            </div>
                                            <label className="footer-label">
                                                Name
                                            </label>
                                            <input ref={name} type="text" className="footer-input">
                                            </input>
                                            <label className="footer-label message-label">
                                                Message
                                            </label>
                                            <input ref={message} type="text" className="footer-input message-input">
                                            </input>
                                            <Button className="submit-message" onClick={sendEmail}>Submit</Button>
                                        </div>
                                    </div>
                                </div>
                                {/* <div>
                                    <ul className="footer-navbar">
                                        <li>Home</li>
                                        <li>Company</li>
                                        <li>Blog</li>
                                        <li>Contact Us</li>
                                        <li>Sitemap</li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>
        </>

    )
}

export default Home;
